import { render, staticRenderFns } from "./gj-setting-modal.vue?vue&type=template&id=ba0ac568&scoped=true&"
import script from "./gj-setting-modal.vue?vue&type=script&lang=js&"
export * from "./gj-setting-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-setting-modal.vue?vue&type=style&index=0&id=ba0ac568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ac568",
  null
  
)

export default component.exports